import { createSvgComponent } from "../../icon/createSvgComponent";
import CalendarBlank from "@core/__generated__/icon/figma/calendar-blank.svg";
export default createSvgComponent(CalendarBlank);